



































































































































































































































































































































































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { ToolbarModule } from "@/store/modules/toolbar"
import { AppModule } from "@/store/modules/app"
import { TreasureBookModule } from '@/store/modules/treasureBook'
import { ImageClipper } from "@/utils/imageClipper";
import { SingleAssetUsage, AssetFile, AssetsModule } from "@/store/modules/asset";
import App from "../../../App.vue";
import { faThinkPeaks } from '@fortawesome/free-brands-svg-icons';
import { CoverType } from '@/rest/models'

@Component({
  name: "book-preview"
})
export default class BookPreview extends Vue {
  private flipcounter: number = 0;
  private mobileFlipCounter: number = 1;
  private boxCount: number = 0;
  private currentPos: number = 0;
  private currentPosMobile: number = 1;
  private degFac: number = 0;
  private mobilePageGap: number = 50;
  private initiated: boolean = false;
  private numberOfPages: number = 43;
  private innerImageClipper = ImageClipper.getImageClipper(false, 2);
  private innerImageUrl = "";
  private innerDefault = true;
  private scaleFac = 465.0 / 420.0;
  private scaleFacX = 465.0 / 300.0;
  private scaleFacY = 653.0 / 420.0;
  private pagesLoaded = 0;
  private isLoading = true;
  private internalClose = false;
  private pagesWithText = [4,7,8,10,13,14,16,18,21,23,24,27]
  private pageIndex = [29, 27, 25, 23, 21, 19, 17, 15, 13, 11, 9, 7, 5, 3, 1]

  init() {
    window.addEventListener("resize", this.resized);
    this.boxCount = this.pageIndex.length;
    this.currentPos = this.boxCount;
    this.currentPosMobile = this.boxCount * 2;
    for (let i: number = 0; i < this.pageIndex.length; i++) {
      let degree: number = i * this.degFac;
      let translatex: number =
        i * (this.mobilePageWidth * 2 + this.mobilePageGap) +
        (1.5 * this.mobilePageGap + this.mobilePageWidth);
      var pages = this.$refs.page as HTMLElement[];
      pages[i].className = pages[i].className.replace(" show-back", "");
      pages[i].style.transform = "rotateY(-" + degree + "deg)";
      pages[i].style.zIndex = "0";
      (this.$refs.mobilePage as HTMLElement[])[
        this.boxCount - 1 - i
      ].style.transform = "translateX(" + translatex + "px)";
    }
    (this.$refs.forward as HTMLElement).style.opacity = "100";

    (this.$refs.back as HTMLElement).style.opacity = "0";
    if (TreasureBookModule.name === ""){
      TreasureBookModule.SetName("Name des Kindes")
    }
    this.initiated = true;
  }

  mounted() {
    this.init();
    this.resized()
    /* this.registerFullScreenChange();
    EventBus.register("PREVIEW_OPEN", () => {
      if (this.$refs.preview) {
        this.requestFullScreen(this.$refs.preview);
      }
    });
  }

  beforeDestroy() {
    this.unregisterFullScreenChange();
    EventBus.unregister("PREVIEW_OPEN"); */
  }

  resized() {
    let width = window.innerWidth;
    let height = window.innerHeight;
    let scale = 1;
    if (width <= 1145) {
      if (width > height) {
        scale = height / 820;
      } else {
        scale = width / 700;
      }
    } else if (height < 700) {
      scale = height / 700;
    }
    (this.$refs.container as HTMLElement).style.transform =
      "scale(" + scale + ")";
  }

  progress() {
    return (this.pagesLoaded / this.numberOfPages) * 100.0;
  }

  pageLoaded() {
    this.pagesLoaded++;
    if (this.pagesLoaded == this.numberOfPages) {
      (this.$refs.container as HTMLElement).style.display = "block";
      this.isLoading = false;
    }
  }

  onClose() {
    this.internalClose = true;
    /* this.exitFullScreen(); */
    this.init();
    (this.$refs.mobileContainer as HTMLElement).style.transform =
      "translate(0)";
    (this.$refs.back as HTMLElement).style.opacity = "0";
    AppModule.SetShowPreview(false);
    (document.body as HTMLElement).style.overflow="auto";
    this.internalClose = false;
  }

  forward() {
    if (this.currentPos > 0) {
      this.flipcounter++;
      var box = (this.$refs.page as HTMLElement[])[this.currentPos - 1];
      box.className += " show-back";
      box.setAttribute("style", "z-index: " + this.flipcounter);
      var degree = 180 - (this.boxCount - this.currentPos) * this.degFac;
      box.style.transform = "rotateY(-" + degree + "deg)";
      this.currentPos--;
    }
    if (this.currentPosMobile > 1) {
      this.currentPosMobile--;
      var mobileContainer = this.$refs.mobileContainer as HTMLElement;
      var translate = 0;
      if (this.currentPosMobile % 2 === 1) {
        translate =
          (this.boxCount * 2 - this.currentPosMobile) *
            (this.mobilePageWidth + 0.5 * this.mobilePageGap) +
          this.mobilePageGap;
      } else {
        translate =
          (this.boxCount * 2 - this.currentPosMobile) *
            (this.mobilePageWidth + 0.5 * this.mobilePageGap) -
          0.5 * this.mobilePageGap;
      }
      mobileContainer.style.transform = "translateX(-" + translate + "px)";
    }
    var width = window.innerWidth > 0 ? window.innerWidth : screen.width;

    if (this.currentPosMobile == 1 && width < 1154) {
      (this.$refs.forward as HTMLElement).style.opacity = "0";
    }
    if (this.currentPos == 0 && width > 1154) {
      (this.$refs.forward as HTMLElement).style.opacity = "0";
    }
    (this.$refs.back as HTMLElement).style.opacity = "100";
  }

  back() {
    if (this.currentPos < this.boxCount) {
      this.flipcounter++;
      var box = (this.$refs.page as HTMLElement[])[this.currentPos];
      box.className = box.className.replace(/\bshow-back\b/g, "");
      box.setAttribute("style", "z-index: " + this.flipcounter);
      var degree = (this.currentPos + 1) * this.degFac;
      box.style.transform = "rotateY(-" + degree + "deg)";
      this.currentPos++;
    }
    if (this.currentPosMobile <= this.boxCount * 2 - 1) {
      this.currentPosMobile++;
      var mobileContainer = this.$refs.mobileContainer as HTMLElement;
      var translate = 0;
      if (this.currentPosMobile % 2 === 1) {
        translate =
          (this.boxCount * 2 - this.currentPosMobile) *
            (this.mobilePageWidth + 0.5 * this.mobilePageGap) +
          this.mobilePageGap;
      } else if (this.currentPosMobile == this.boxCount * 2) {
        translate = 0;
      } else {
        translate =
          (this.boxCount * 2 - this.currentPosMobile) *
            (this.mobilePageWidth + 0.5 * this.mobilePageGap) -
          0.5 * this.mobilePageGap;
      }

      mobileContainer.style.transform = "translateX(-" + translate + "px)";
    }
    var width = window.innerWidth > 0 ? window.innerWidth : screen.width;
    if (this.currentPosMobile == this.boxCount * 2 && width < 1154) {
      (this.$refs.back as HTMLElement).style.opacity = "0";
    }
    if (this.currentPos == this.boxCount && width > 1154) {
      (this.$refs.back as HTMLElement).style.opacity = "0";
    }
    (this.$refs.forward as HTMLElement).style.opacity = "100";
  }

  get show() {
    return AppModule.showPreview;
  }

  get visible() {
    if (this.show && this.initiated) {
      return true;
    }
    return false;
  }

  @Watch("visible")
  visibleChanged(visible: boolean) {
    if (visible) {
      let { usage: usageInner, asset: assetInner } = this.evaluateInnerImage();
      if (assetInner && usageInner) {
        this.innerImageUrl = assetInner.url;
        this.innerImageClipper.initializeUsage(usageInner, assetInner.rect);
        this.innerDefault = false;
      } else {
        this.innerImageUrl = "";
        this.innerDefault = true;
      }
    }
  }

  get shadowIndex() {
    if (this.currentPos == 0) {
      return -1;
    } else if (this.currentPos == this.boxCount) {
      return 1;
    } else {
      return 0;
    }
  }

  get name() {
    return TreasureBookModule.name;
  }

  get dedication() {
    return TreasureBookModule.dedication
  }

  get dedicationText() {
    if(TreasureBookModule.dedication.text == undefined) {
      return ""
    }
    return TreasureBookModule.dedication.text.replace(/\n/g, "<br>");
  }

  get dedicationEmpty(){
    if (TreasureBookModule.dedication.text === '' || TreasureBookModule.dedication.text == undefined){
      return true
    }
    return false
  }

  get parentGender() {
    return TreasureBookModule.parentGender
  }

  get text() {
    return TreasureBookModule.text
  }

  get coverType() {
    return TreasureBookModule.coverType
  }

  get mobilePageWidth(){
    return this.coverType === 'hardCover' ? 475 : 465
  }

  @Watch("coverType")
  coverTypeChanged(coverType: CoverType) {
    this.$nextTick(() => {
      this.init()
    })
  }

  /* private requestFullScreen(el: any) {
    let requestFullScreen = (name: string) => {
      window.console.log("try request full sreen with " + name);
      if (el[name]) {
        let promise = el[name]();
        if (promise) {
          promise.then(
            () => {
              window.console.log("request full sreen succeeded with " + name);
            },
            (err: any) => {
              window.console.log("request full sreen failed with " + name, err);
            }
          );
        } else {
          window.console.log("request full sreen succeeded with " + name);
        }
        return true;
      }
      return false;
    };
    requestFullScreen("requestFullscreen") ||
      requestFullScreen("mozRequestFullScreen") ||
      requestFullScreen("webkitRequestFullscreen") ||
      requestFullScreen("msRequestFullscreen");
  } */

  private exitFullScreen() {
    let exitFullScreen = (name: string) => {
      window.console.log("try exit full sreen with " + name);
      if ((document as any)[name]) {
        let promise = (document as any)[name]();
        if (promise) {
          promise.then(
            () => {
              window.console.log("exit full sreen succeeded with " + name);
            },
            (err: any) => {
              window.console.log("exit full sreen failed with " + name, err);
            }
          );
        } else {
          window.console.log("exit full sreen succeeded with " + name);
        }
        return true;
      }
      return false;
    };
    exitFullScreen("exitFullscreen") ||
      exitFullScreen("mozCancelFullScreen") ||
      exitFullScreen("webkitExitFullscreen") ||
      exitFullScreen("msExitFullscreen");
  }

  /* private fullscreenExitHandler() {
    if (!(document as any).fullscreenElement && 
        !(document as any).webkitIsFullScreen && 
        !(document as any).mozFullScreen && 
        !(document as any).msFullscreenElement) {
      if (!this.internalClose && this.show) {
        this.init();
        (this.$refs.mobileContainer as HTMLElement).style.transform =
          "translate(0)";
        (this.$refs.back as HTMLElement).style.opacity = "0";
        AppModule.SetShowPreview(false);
      }
    }
  }

  private registerFullScreenChange() {
    if (document.addEventListener) {
      document.addEventListener('fullscreenchange', this.fullscreenExitHandler, false);
      document.addEventListener('mozfullscreenchange', this.fullscreenExitHandler, false);
      document.addEventListener('MSFullscreenChange', this.fullscreenExitHandler, false);
      document.addEventListener('webkitfullscreenchange', this.fullscreenExitHandler, false);
    }  
  }

  private unregisterFullScreenChange() {
    if (document.removeEventListener) {
      document.removeEventListener('fullscreenchange', this.fullscreenExitHandler);
      document.removeEventListener('mozfullscreenchange', this.fullscreenExitHandler);
      document.removeEventListener('MSFullscreenChange', this.fullscreenExitHandler);
      document.removeEventListener('webkitfullscreenchange', this.fullscreenExitHandler);
    }  
  } */

  private evaluateInnerImage(): {
    usage?: SingleAssetUsage;
    asset?: AssetFile;
  } {
    let asset;
    let usage;
    window.console.log(AppModule.currentStepIndex);
    if (AppModule.currentStepIndex !== 2) {
      let assetId = TreasureBookModule.innerImageAssetId;
      if (assetId >= 0) {
        for (let currentAsset of AssetsModule.assets) {
          if (currentAsset.assetId === assetId) {
            asset = currentAsset;
            break;
          }
        }
      }
      if (asset && AppModule.steps[2].usageName) {
        usage = asset.usage[AppModule.steps[2].usageName];
        if (usage) {
          return { usage: usage as SingleAssetUsage, asset };
        }
      }
    } else {
      let asset: AssetFile | undefined = AssetsModule.selected;
      if (asset) {
        let center = [...ToolbarModule.center];
        let usage: SingleAssetUsage = {
          rotation: ToolbarModule.rotation,
          zoom: ToolbarModule.zoom,
          center: center as [number, number]
        };
        return { usage, asset };
      }
    }
    return {};
  }

  get imageSuffix() {
    if (this.parentGender === 'male') {
      return '-papa'
    }
    return ''
  }

  classSuffix(index: number) {
    if (this.parentGender === 'male') {
      if (index  === 5 || index  === 25 || index  === 26) {
        return '-papa'
      }
    }
    return ''
  }

  classDefault (index: number) {
    if(this.innerDefault && index === 26){
      return '-default'
    }
    return ''
  }
  hasText (index: number) {
    return (this.pagesWithText.includes(index))
  }
  
  formatText (text: string) {
    return text.split('\n').join('<br>')
  }
  getText(index: number) {
    return this.formatText(this.text[this.pagesWithText.indexOf(index)])
  }
  coverSuffix(index: number) {
    if (this.coverType === 'softCover') {
      if (index  === 2 || index  === 29) {
        return 'sc-'
      }
    }
    return ''
  }
}
